import { AppState } from "../../../redux-configuration/AppState";

export const registerBusinessLoadingSelector =  (appState: AppState): boolean => appState.registration.registerBusiness.loading
export const registerBusinessErrorSelector = (appState: AppState): string | undefined => appState.registration.registerBusiness.error
export const registeredBusinessIdSelector = (appState: AppState):  string | undefined => appState.registration.registerBusiness.businessId
